/**
 * ContractDetailPage - a single contract's lifecycle detail at
 * /contracts/:contractUuid. Facts, renewal timeline, parties, obligations,
 * source alignment and review risk, with quick actions.
 */
import { useContext, useEffect } from 'react';
import ContractDetail from '../components/Contracts/ContractDetail';
import { LayoutContext } from '../contexts/LayoutContext';

function ContractDetailPage() {
  const { setIsContentScrollable } = useContext(LayoutContext);
  useEffect(() => {
    setIsContentScrollable(false);
    return () => { setIsContentScrollable(true); };
  }, [setIsContentScrollable]);

  return <ContractDetail />;
}

export default ContractDetailPage;
